import type { PreloadedQuery } from 'react-relay';
import type { csmFolderSearchArticlesForSupportSiteQuery } from './__generated__/csmFolderSearchArticlesForSupportSiteQuery.graphql';

export interface CsmFolderQueryProps {
    queryReference: PreloadedQuery<csmFolderSearchArticlesForSupportSiteQuery>;
}

export const MAX_ITEMS_PER_PAGE = 24;
